import { $createParagraphNode, $getSelection, LexicalEditor } from 'lexical';
import { $createHeadingNode, HeadingTagType } from '@lexical/rich-text';
import { $setBlocksType } from '@lexical/selection';

import { MenuItem } from '../../../../../MenuItem';
import { Typography } from '../../../../../Typography';

type BlockTypeToBlockName = {
  h5: string;
  h6: string;
  paragraph: string;
};

export const blockTypeToBlockName: BlockTypeToBlockName = {
  h5: 'Заголовок 1',
  h6: 'Заголовок 2',
  paragraph: 'Обычный текст',
};

export type BlockTypeKeys = keyof BlockTypeToBlockName;

export const useTagsItems = (editor: LexicalEditor, activeTag: string) => {
  const formatHeading = (headingSize: HeadingTagType) => {
    editor.update(() => {
      const selection = $getSelection();
      $setBlocksType(selection, () => $createHeadingNode(headingSize));
    });
  };

  const formatParagraph = () => {
    editor.update(() => {
      const selection = $getSelection();
      $setBlocksType(selection, () => $createParagraphNode());
    });
  };

  const handleFormat = (value: string) => {
    if (value === 'paragraph') {
      formatParagraph();
    }

    if (value === 'h5' || value === 'h6') {
      formatHeading(value);
    }
  };

  return Object.entries(blockTypeToBlockName).map(([tag, text]) => {
    let currentHeaderTag: 'h5' | 'h6' = 'h5';

    if (tag === 'h6') {
      currentHeaderTag = 'h6';
    }

    return (
      <MenuItem onClick={() => handleFormat(tag)} key={tag}>
        <Typography
          variant={tag === 'paragraph' ? 'body2' : currentHeaderTag}
          color={
            activeTag === tag ? 'original.brand.primary' : 'text.light.primary'
          }
        >
          {text}
        </Typography>
      </MenuItem>
    );
  });
};
